export default __webpack_public_path__ + "static/media/cranium_crusher.a47b1754.png";